module.exports = __webpack_public_path__ + "img/screenshot-step1.a7d6a0ce.png";